import {isDefined} from "../../libs/utils/epic.utils";
import {OrgLifecycle} from "../../libs/enum/org-lifecycle.enum";

/**
 * Der Zustand einer gekündigten Organisation. Fehlt das Feld, läuft der Vertrag.
 *
 * ⚠️ Alle Fristen kommen fertig gerechnet aus dem Backend — `contractEnded + 90` hier nachzurechnen hieße, dieselbe
 * Frist an einer zweiten Stelle zu führen, und die Anzeige liefe irgendwann von der Sperre weg.
 */
export class OrgLifecycleDto {

  public readonly state!: OrgLifecycle;
  public readonly contractEnded!: Date;
  public readonly deletionDue!: Date;
  /** Volle Tage bis zur Löschung. Kommt fertig gerechnet aus dem Backend und altert in einer lange offenen Sitzung. */
  public readonly daysLeft!: number;

  constructor(init?: Partial<OrgLifecycleDto> | undefined) {
    Object.assign(this, init);
    if (isDefined(init?.contractEnded)) {
      this.contractEnded = new Date(init.contractEnded);
    }
    if (isDefined(init?.deletionDue)) {
      this.deletionDue = new Date(init.deletionDue);
    }
  }
}
